import { View, StyleSheet } from "react-native";
import { FloatingPortal } from "@floating-ui/react";
import { useToasts, useToast } from "../../contexts/ToastContext";
import Toast from "./Toast";

const TOAST_Z_INDEX = 140000;

const ToastContainer = () => {
  const toasts = useToasts();
  const { hideToast } = useToast();

  if (toasts.length === 0) {
    return null;
  }

  return (
    <FloatingPortal>
      <View style={styles.container} pointerEvents="box-none">
        <View pointerEvents="box-none">
          {toasts.map((toast) => (
            <View key={toast.id} pointerEvents="auto">
              <Toast toast={toast} onDismiss={hideToast} />
            </View>
          ))}
        </View>
      </View>
    </FloatingPortal>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "fixed",
    top: 16,
    left: 0,
    right: 0,
    alignItems: "center",
    zIndex: TOAST_Z_INDEX,
  },
});

export default ToastContainer;
